import React from "react";
import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";

const { Header } = Layout;

const Navbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <Header
      className="header"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "0 20px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <h4 style={{ margin: 0, color: "#000" }}>Uptake Loan Management</h4>
      </div>
      <Menu
        theme="light"
        mode="horizontal"
        style={{ flex: 1, justifyContent: "flex-end" }}
      >
        <Menu.Item key="1" onClick={handleLogout}>
          Logout
        </Menu.Item>
      </Menu>
    </Header>
  );
};

export default Navbar;
